module.exports = __webpack_public_path__ + "static/img/logo-OB.83680ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardPH/img/logo-OB.png
// module id = EPts
// module chunks = 1